'use strict';

import React, { Fragment } from 'react'

import Slider from 'react-slick'

import { CSSTransition, TransitionGroup } from 'react-transition-group'

import _ from 'lodash'

import Layout from '@Layout/ECFront'

import HolidaysMessage from '@/HolidaysMessage'

import GMap from '@/Maps/GMap'

import Loader from '@Pure/Loader'
import Image  from '@Pure/Image'
import Link   from '@Pure/Link'

let app = window.app;

export default class FrontPlacePage extends React.Component
{
	constructor (props)
	{
		super(props);

		this.state =
		{
			place: { },
			references: [],
			loading: false
		};

		this.gmap_rdy = false;
	}

	componentDidUpdate ()
	{
		if (window.objectFitImages instanceof Function)
		{
			window.objectFitImages();
		}
	}

	componentDidMount ()
	{
		if (window.objectFitImages instanceof Function)
		{
			window.objectFitImages();
		}
	}

	componentWillMount ()
	{
		const component = this, props = this.props;

		app.resetFunctions();

		let id = document.location.pathname.split('/');

		id = id[id.length-1] ? id[id.length-1] : id[id.length-2];

		let filter_query =
		{
			id: id
		};

		let tabs =
		[
			{ name: 'prices', label: 'Informations' },
			{ name: 'places', label: 'Localisation' },
			{ name: 'images', label: 'Images' }
		];

		component.setState(
		{
			loading: true,
			active_tab: 'prices',
			tabs: tabs
		});

		qwest.post('/CMS/getAll',
		{
			model: 'place',
			filter_query: JSON.stringify(filter_query)
		})
		.then(function (xhr, response)
		{
			let place = response.data[0];

			component.setState(
			{
				place: place,
				references: response.references,
				loading: false
			});
		})
		.catch(function (error, xhr, response)
		{
			console.error(xhr, response, error);

			component.setState(
			{
				loading: false
			});

			app.ajaxRedirectLogin(response);
		});
	}

	getPlaceLabel = (place_data) =>
	{
		let place_label = [];

		let is_line_2_first = false;

		const address = place_data.address || { };

		if (typeof address.line_2 === 'string')
		{
			let line_2 = address.line_2;

			is_line_2_first = ['Zone', 'ZI', 'ZA', 'Espace']
			.find(function (str)
			{
				return line_2.toLowerCase().indexOf(str.toLowerCase()) !== -1;
			});
		}

		if (place_data.name && place_data.name !== address.line_1 &&
			place_data.name !== address.line_2 )
		{
			place_label.push(place_data.name);
		}

		if (is_line_2_first && address.line_2)
		{
			place_label.push(address.line_2);
		}

		if (address.line_1)
		{
			place_label.push(address.line_1);
		}

		if (!is_line_2_first && address.line_2)
		{
			place_label.push(address.line_2);
		}

		if (address.zip_code)
		{
			place_label.push(address.zip_code);
		}

		if (address.city)
		{
			if (address.zip_code)
			{
				place_label[place_label.length-1] += ' ' + address.city;
			}
			else
			{
				place_label.push(address.city);
			}
		}

		if (place_label.length > 1)
		{
			place_label = place_label.join(', ');
		}
		else if (place_label.length === 1 && place_label[0])
		{
			place_label = place_label[0];
		}
		else
		{
			place_label = '';
		}

		return place_label;
	}

	render ()
	{
		const component = this, props = this.props, place = component.state.place;

		const state = this.state;

		let loader;

		if (state.loading === true)
		{
			loader =
			(
				<Loader className="c-loader"
					bemit={ ['primary', 'bg-white', 'big'] } />
			);
		}

		let images = (place.images || [])
		.map(function (data, index)
		{
			var output =
			(
				<div key={ index }>
					<Image className="c-model__carousel-image" src={ data.url } />
				</div>
			);

			return output;
		});

		const slider_settings =
		{
			dots: true,
			infinite: false,
			speed: 320,
			slidesToShow: 1,
			slidesToScroll: 1,
			swipeToSlide: true,
			useCSS: true,
			breakpoint: 100,
			draggable: true
		};

		if (state.loading === false)
		{
			component.gmap_rdy = true;
		}

		let google_map;

		let place_label = component.getPlaceLabel(place);

		if (component.gmap_rdy === true)
		{
			place.address = place.address || { };

			let address =
			{
				name: place.name,
				line_1: place.address.line_1,
				line_2: place.address.line_2,
				zip_code: place.address.zip_code,
				city: place.address.city,
				label: place_label
			};

			const pins = [place].map(function (place)
			{
				if (!(place.geocoding || [])[0]) return;

				let [lat, lng] = place.geocoding[0].geometry.location
				.replace('(', '').replace(')', '')
				.split(', ');

				lat = Number(lat);
				lng = Number(lng);

				if (isNaN(lat) || isNaN(lng)) return;

				const data =
				{
					position: { lat: lat, lng: lng },
					name: place.name
				};

				return data;
			})
			.filter(data => data && data.position);

			google_map =
			(
				<GMap className="c-model__gmap" address={ address }
					pins={ pins }
				/>
			);
		}

		let localisation =
		(
			<Fragment>

				<div className="c-model__map">

					{ google_map }

				</div>

			</Fragment>
		);

	/**
	 * Display only tabs with data
	 *
	 * @type    { Array }
	 **/
		let tabs = state.tabs
		.filter(function (tab_infos, key)
		{
			if (tab_infos.name === 'images')
			{
				if (images.length <= 0) return false;
			}

			return true;
		})
		.map(function (tab_infos, key)
		{
			let label = tab_infos.label;

			if (tab_infos.name === 'places')
			{
				label = 'Localisation';
			}

			let output =
			(
				<button key={ key } onClick={ function (e)
					{ component.setState({ active_tab: tab_infos.name }) } }
					className={ 'c-tab' + (state.active_tab === tab_infos.name ?
					' c-tab--active' : '') }>

					<div className="c-tab__label">
						{ label }
					</div>

				</button>
			);

			return output;
		});

		let content;

		if (state.active_tab === 'prices')
		{
			let place_infos =
			(
				<div className="c-model__places u-margin-top-20">
					<svg className="o-svg-icon o-svg-icon--tracker c-model__places-icon">
						<use xlinkHref="/images/icons.svg#svg-icon-tracker"></use>
					</svg>

					{ place_label }
				</div>
			);

			let description = (place.description || '')
			.split('<p><br></p>')
			.join('')
			.split('<script>')
			.join('')
			.split('</script>')
			.join('');

			content =
			(
				<div className="c-model__body">

					<div className="o-content">

						<div className="c-subtitle u-margin-top-0">
							<h2 className="c-subtitle__txt">
								{ place.name }
							</h2>
						</div>

					</div>

					<div className="o-grid-2">

						<div className="o-grid__item-7">

							{ place_infos }

							<div className="c-model__description"
								dangerouslySetInnerHTML= { { __html: description } }>
							</div>

						</div>

						<div className="o-grid__item-5">

							<div className="c-model__image">
								{
									images
									? images[0] || undefined
									: undefined
								}
							</div>

						</div>

					</div>

				</div>
			);
		}
		else if (state.active_tab === 'places')
		{
			place.infos = place.infos || { };

			let links =
			[
				place.infos.twitter,
				place.infos.facebook,
				place.infos.website,
				place.infos.instagram
			];

			links = links
			.map(function (link, i)
			{
				if (!link || link.trim() === '') return undefined;

				if (link.indexOf('http') === -1)
				{
					if (i < 2)
					{
						link = 'https://' + link;
					}
					else
					{
						link = 'http://' + link;
					}
				}
				else if (link.indexOf('https') === -1 && i !== 2)
				{
					link = link.replace('http', 'https');
				}

				return link;
			});

			let email     = place.infos.email, phone = place.infos.phone;
			let twitter   = links[0], facebook = links[1], website = links[2];
			let instagram = links[3];

			if (twitter)
			{
				twitter =
				(
					<a className="c-model__social" href={ twitter } target="_blank">
						<svg className="o-svg-icon o-svg-icon--twitter c-model__social-icon">
							<use xlinkHref="/images/icons.svg#svg-icon-twitter"></use>
						</svg>
					</a>
				);
			}

			if (facebook)
			{
				facebook =
				(
					<a className="c-model__social" href={ facebook } target="_blank">
						<svg className="o-svg-icon o-svg-icon--facebook c-model__social-icon">
							<use xlinkHref="/images/icons.svg#svg-icon-facebook"></use>
						</svg>
					</a>
				);
			}

			if (instagram)
			{
				instagram =
				(
					<a className="c-model__social" href={ instagram } target="_blank">
						<svg className="o-svg-icon o-svg-icon--instagram c-model__social-icon">
							<use xlinkHref="/images/icons.svg#svg-icon-instagram"></use>
						</svg>
					</a>
				);
			}

			if (website)
			{
				website =
				(
					<div className="c-model__social-media">
						<a className="c-model__social" href={ website } target="_blank">
							<svg className="o-svg-icon o-svg-icon--website c-model__social-icon">
								<use xlinkHref="/images/icons.svg#svg-icon-website"></use>
							</svg>

							<div className="c-model__social-text">
								Site web&nbsp;:
								{
									' ' +
									website
									.replace('http://', '')
									.replace('https://', '')
									.replace('www.', '')
								}
							</div>
						</a>
					</div>
				);
			}

			if (email)
			{
				email =
				(
					<div className="c-model__social-media">
						<a className="c-model__social" target="_blank" href=
							{
								( email.indexOf('@') !== -1 ? ('mailto:' + email) : email)
							}>
							<svg className="o-svg-icon o-svg-icon--mail c-model__social-icon">
								<use xlinkHref="/images/icons.svg#svg-icon-mail"></use>
							</svg>

							<div className="c-model__social-text">
								{
									' ' +
									email
									.replace('http://', '')
									.replace('https://', '')
									.replace('www.', '')
								}
							</div>
						</a>
					</div>
				);
			}

			if (phone)
			{
				phone =
				(
					<a className="c-model__social" href={ 'tel:' + email }>
						<svg className="o-svg-icon o-svg-icon--phone c-model__social-icon">
							<use xlinkHref="/images/icons.svg#svg-icon-phone"></use>
						</svg>

						<div className="c-model__social-text">
							{
								' ' + app.getSpacedPhoneNumber(phone)
							}
						</div>
					</a>
				);
			}

			let place_label = component.getPlaceLabel(place);

			let social_medias;

			if (twitter && facebook && instagram)
			{
				social_medias =
				(
					<div className="c-model__social-media u-flex u-content-center">
						{ twitter }
						{ facebook }
						{ instagram }
					</div>
				);
			}

			let images, slider;

			if (place.images && place.images.length > 0)
			{
				images = (place.images || []).map(function (data, index)
				{
					let output =
					(
						<div key={ index }>
							<Image className="c-model__place-carousel-image"
								src={ data.url } />
						</div>
					);

					return output;
				});

				slider =
				(
					<div className="c-model__place-images">
						<Slider { ...slider_settings }>
							{ images }
						</Slider>
					</div>
				);
			}

			let places =
			(
				<div className="o-grid__item u-flex" key={ place.id }>

					<div className="c-model__place-infos">
						<div className="c-model__social-media">
							<div className="c-model__social-media-title">
								<svg className="o-svg-icon o-svg-icon--tracker c-model__places-icon">
									<use xlinkHref="/images/icons.svg#svg-icon-tracker"></use>
								</svg>
								{ place_label }
							</div>
						</div>

						{ website }

						{ email }

						{ phone }

						{ social_medias }

					</div>

				</div>
			);

			content =
			(
				<div className="c-model__body">
					<div className="c-subtitle u-margin-top-0">
						<h2 className="c-subtitle__txt">
							Où trouver ce lieu&nbsp;?
						</h2>
					</div>

					{ localisation }

					<div className="u-negative-margins">
						<div className="o-grid-2 u-margin-top-20">
							{ places }
						</div>
					</div>

				</div>
			);
		}
		else if (state.active_tab === 'images' && images.length)
		{
			content =
			(
				<div className="c-model__body">

					<div className="o-grid">

						<div className="o-grid__item-12">

							<div className="c-model__images">
								<Slider { ...slider_settings }>
									{ images }
								</Slider>
							</div>

						</div>

					</div>

				</div>
			);
		}

		let output =
		(
			<Layout page_title={ place.name || '' } history={ props.history }>

				<div className="page-content c-model c-model--place">

					<HolidaysMessage />

					<div className="c-model__content-wrapper">

						<div className="c-model__tabs">{ tabs }</div>

						<div className="c-model__content">
							{ content }
						</div>

						{ loader }

					</div>

				</div>

			</Layout>
		);

		return output;
	}
}
